import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'novus-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent {

  constructor() { }

}
